import React, { useEffect, useState, useCallback } from 'react';
import { SepaTransaction, ClienteSepa } from '../../types/index';
import { X } from 'lucide-react';
import { fetchSepaClientsByTransactionId } from '../../services/api/sepaService';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    transactionId: string;
}

const ViewMoreModal: React.FC<ModalProps> = ({ isOpen, onClose, transactionId }) => {
    const [loading, setLoading] = useState(true);
    const [sepaClients, setSepaClients] = useState<ClienteSepa[]>([]);
    const [registersCount, setRegistersCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    

    const fetchTransactionClients = useCallback(async () => {
        if (!transactionId) return;
        try {
            const data: ClienteSepa[] = await fetchSepaClientsByTransactionId(transactionId);
            console.log("Sepa Clients fetched:", data);
            
            setSepaClients(data);
            setRegistersCount(data.length);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching clients:', error);
            setLoading(false);
        }
    }, [transactionId]);

    useEffect(() => {
        if (isOpen) {
            fetchTransactionClients();
        }
    }, [isOpen, fetchTransactionClients]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    const filteredClients = sepaClients.filter(client => 
        client.cliente_info.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.cliente_info.telefono.includes(searchTerm) ||
        (client.cliente_info.email ?? '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center overflow-y-auto h-full w-full p-4">
            <div className="bg-white p-4 rounded-lg shadow-lg w-full h-[80%] max-w-xl overflow-y-auto relative">
                <button onClick={onClose} className="absolute top-2 right-2 p-1.5 rounded bg-red-500 hover:bg-red-600 flex items-center justify-center">
                    <X className="w-6 h-6 text-white font-bold hover:text-gray-700" />
                </button>
                <h2 className='p-2 font-bold'>Detalles de SEPA Clientes</h2>
                <input
                    type="text"
                    placeholder="Buscar por nombre, teléfono o email"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="border p-2 mb-4 w-full"
                />
                {loading && <p>Cargando…</p>}
                {filteredClients && filteredClients.length > 0 ? (
                    <div className="space-y-4">  
                        <div className=' flex justify-start gap-10'>                  
                            <h3 className='pl-2 font-bold flex-grow'>Total de Registros: {registersCount}</h3>
                        </div>
                        {filteredClients.map((client) => (
                            <div key={client.cliente_id} className="border p-2 rounded-lg">
                                <h4 className="font-bold text-blue-500">{client.cliente_info.nombre}</h4>
                                <p> <strong>Teléfono:</strong>  {client.cliente_info.telefono}</p>
                                <p> <strong>Email:</strong>  {client.cliente_info.email}</p>
                                <p> <strong>IBAN:</strong>  {client.iban}</p>
                                <p><strong>Importe:</strong> {client.importe} €</p>
                                <p><strong>Observaciones:</strong> {client.observaciones}</p>
                                {/* <p>Suscripción: {client.suscripcion_id}</p> */}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No se encontraron clientes históricos.</p>
                )}
                <div className="flex justify-end py-4">
                    <button onClick={onClose} className="mr-2 px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800">Cancelar</button>
                </div>
            </div>
        </div>
    );
};

export default ViewMoreModal;